import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import axios from 'axios';
import Typography from 'material-ui/Typography';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import Send from 'material-ui-icons/ChevronLeft';

import {overlapOpen} from './actions';

class Close extends Component {

  onSelect(access_id, myComponent) {
    myComponent.props.overlapOpen(false, "0000");
  }

  render(){
    const { classes, theme, location, data } = this.props;
    console.log("data button is"+ data["access id"])

    var access_id = data["access id"]
    let myComponent = this;

    return(
      <div className={classes.root}>
        <Button className={classes.topClick} onClick={() => this.onSelect(access_id, myComponent)} raised color="primary" >
          <Send className={classes.rightIcon}/>
          <div className={classes.text}>
            Go Back
          </div>
          <Typography type="body2" className={classes.typo}>
            -  ID: {access_id}
          </Typography>
        </Button>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
      overlapOpen: overlapOpen
    }, dispatch);
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, matchDispatchToProps)(Close)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/Candidate/components/User/scenes/Core/components/Close/index.js